import { AccessReportsWizardOption } from "@app/access-reports/shared/accessReportsWizardOption";

class AccessReportsWizardSummaryPage {
  accessSummary: boolean;
  accessFilter: AccessReportsWizardOption;
  chartPercentage1: string;
  chartPercentage1Color: string;
  chartPercentage2: string;
  chartPercentage2Color: string;
  chartPercentage3: string;
  chartPercentage3Color: string;
  chartPercentage4Color: string;
  columns: AccessReportsWizardOption[];
  id: number;
  summarizeBy: AccessReportsWizardOption;
  summaryType?: AccessReportsWizardOption;

  constructor(accessSummary: boolean, id: number) {
    this.accessSummary = accessSummary;
    this.accessFilter = null;
    this.chartPercentage1 = "";
    this.chartPercentage1Color = "";
    this.chartPercentage2 = "";
    this.chartPercentage2Color = "";
    this.chartPercentage3 = "";
    this.chartPercentage3Color = "";
    this.chartPercentage4Color = "";
    this.columns = [];
    this.id = id;
    this.summarizeBy = null;
    this.summaryType = null;
  }
}

export { AccessReportsWizardSummaryPage };
